import { RealTimePlaybackKey } from '@ftr/data-realtime-playback'

export class RealTimeSessionsUpdatedEvent {
  static readonly type = '[RealTimeSessions] Sessions Updated'

  constructor(readonly playbackKey: RealTimePlaybackKey) {}
}
